import {ApplicationUserDto, ApplicationUserRole} from "../../api";
import {ColumnsType} from "antd/es/table";
import {CrudTable, nameof} from "digimuth-components/dist";
import {CrudTableWrapperProps} from "digimuth-components/dist/components/crudTable/crudTable";
import {Button, Tag} from "antd";
import styles from "./userList.module.scss";
import {generatePath, useNavigate} from "react-router-dom";
import {RoutingPaths} from "../routing/routingContainer";
import {enumRoles} from "./userModalForm/userModalForm";

export default function UserList(props: UserProps) {

    const navigate = useNavigate();

    const columns: ColumnsType<ApplicationUserDto> = [
        {
            key: nameof<ApplicationUserDto>("email"),
            title: "Mail",
            dataIndex: nameof<ApplicationUserDto>("email")
        },
        {
            key: nameof<ApplicationUserDto>("firstName"),
            dataIndex: nameof<ApplicationUserDto>("firstName"),
            title: "Imię"
        },
        {
            key: nameof<ApplicationUserDto>("lastName"),
            dataIndex: nameof<ApplicationUserDto>("lastName"),
            title: "Nazwisko"
        },
        {
            key: nameof<ApplicationUserDto>("phoneNumber"),
            dataIndex: nameof<ApplicationUserDto>("phoneNumber"),
            title: "Numer telefonu"
        },
        {
            key: nameof<ApplicationUserDto>("emailConfirmed"),
            title: "Konto aktywowane",
            dataIndex: nameof<ApplicationUserDto>("emailConfirmed"),
            render: (emailConfirmed) => emailConfirmed ? <Tag color="green">Tak</Tag> : <Tag color="red">Nie</Tag>
        },
        {
            key: nameof<ApplicationUserDto>("newsletter"),
            dataIndex: nameof<ApplicationUserDto>("newsletter"),
            title: "Newsletter",
            render: (newsletter: boolean) => newsletter ? <Tag color="green">Tak</Tag> : <Tag color="red">Nie</Tag>
        },
        {
            key: nameof<ApplicationUserDto>("roles"),
            title: "Role",
            dataIndex: nameof<ApplicationUserDto>("roles"),
            render: (roles: ApplicationUserRole[]) => <div>
                {roles.map((role: ApplicationUserRole, index: number) => <Tag key={index} color={"blue"}>
                    {enumRoles.find(x => x.value == role)?.label}
                </Tag>)}
            </div>
        }
    ]

    function onRecordClick(id: number) {
        navigate(generatePath(RoutingPaths.userAddress.route, {
            userId: id.toString()
        }));
    }

    return <div>
        <Button type="primary" onClick={props.onAddClicked} className={styles.newUserButton}>
            + Dodaj nowego użytkownika
        </Button>
        <CrudTable
            data={props.data}
            onDeleteClicked={props.onDeleteClicked}
            columns={columns}
            actionsFixed={false}
            deleteButtonTitle="Usuń"
            deleteConfirmMessage="Czy na pewno chcesz usunąć tego użytkownika?"
            cancelButtonTitle="Anuluj"
            isLoading={props.isLoading}
            addButtonTitle={"Dodaj nowego użytkownika"}
            customRowActions={record => <>
                <Button onClick={() => onRecordClick(record.id!)}>
                    Adresy
                </Button>
                {!record.emailConfirmed
                    ? <Button
                        onClick={() => props.onResendInvitation(record.email!)}
                    >
                        Ponownie wyślij zaproszenie
                    </Button>
                    : <Button
                        onClick={() => props.onEditClicked!(record.id!)}
                    >
                        Edytuj
                    </Button>
                }
            </>}
        />
    </div>
}

interface UserProps extends CrudTableWrapperProps<ApplicationUserDto> {
    onAddClicked: () => void,
    onResendInvitation: (email: string) => void;
}
